import * as React from 'react'
import { observer } from 'mobx-react'
import { Questionnaire } from '../../../Model/Questionnaire'
import AddProductsCreateQ from './AddProductsCreateQ'
import { getCreditConditionForm } from '../../../Model/CreditCondition'
import { getAgentInfoForm } from '../../../Model/AgentInfo'

export interface IQuestionnaireCreateDetailsViewProps {
    questionnaire: Questionnaire
    className?: string
}

@observer
export default class QuestionnaireCreateDetailsView
    extends React.Component<IQuestionnaireCreateDetailsViewProps> {

    constructor(props: any) {
        super(props)
    }

    render() {
        const { questionnaire } = this.props

        if (!questionnaire) {
            return null
        }

        return (
            <div className={this.props.className}>
                <div className="detailsViewWrapper">
                    {getCreditConditionForm(questionnaire)}
                    {getAgentInfoForm(questionnaire)}
                    <AddProductsCreateQ pageSize={15} />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireCreateDetailsView.tsx